import { render, staticRenderFns } from "./appointment-list-item.vue?vue&type=template&id=45e8a471&scoped=true"
import script from "./appointment-list-item.vue?vue&type=script&lang=js"
export * from "./appointment-list-item.vue?vue&type=script&lang=js"
import style0 from "./appointment-list-item.vue?vue&type=style&index=0&id=45e8a471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8a471",
  null
  
)

export default component.exports